<template>
  <div class="py-4 container-fluid">
    <a :style="search.periode_start == '' ? 'margin-right: 10px; pointer-events: none; cursor: default;' : 'margin-right: 10px;'" style="margin-right: 10px;" :href="apiUrl+'export-excel/absen?periode_start='+search.periode_start+'&periode_end='+search.periode_end+'&nama='+search.nama+''" target="_BLANK"><argon-button :disabled="search.periode_start == ''" color="primary" size="sm" class="mb-3" variant="gradient"><i class="fa fa-file-excel-o" style="margin-right: 5px;"></i> Export Excel</argon-button></a>
    <!-- <argon-button color="warning" size="sm" class="mb-3" variant="gradient"><i class="fa fa-upload fa-sm"></i> Import</argon-button> -->
    <div class=" row">
      <div class="col-12">
          <div class="card"> 
            <div class="row">
              <div class="col-2">
                <div class="card-header pb-0">
                  <h6>Data Absensi</h6>
                </div>
              </div>
              <div class="col-5">
                <p style="margin-top: 25px; font-weight: bold; padding-left: 85px;">PERIODE {{ moment(search.periode_start).locale('id').format('D MMMM').toUpperCase() }} - {{ moment(search.periode_end).locale('id').format('D MMMM YYYY').toUpperCase() }}</p>
              </div>
              <div class="col-5 float-right d-flex align-items-center justify-content-end" style="padding-right: 30px;">
                <input
                  type="text"
                  class="form-control"
                  style="width: 220px; margin-right: 30px;"
                  placeholder="Cari nama karyawan..."
                  v-model="search.nama"
                  @input="getAbsen()"
                >
                <argon-button
                  v-if="search.periode_start != ''"
                  class="mt-4"
                  variant="gradient"
                  color="danger"
                  size="sm"
                  @click="setLibur()"
                ><i class="fa fa-calendar fa-sm" aria-hidden="true"></i> Set Libur</argon-button>
                <argon-button
                  v-if="search.periode_start != ''"
                  style="margin-left: 5px;"
                  class="mt-4"
                  variant="gradient"
                  color="warning"
                  size="sm"
                  @click="setCutiBersama()"
                ><i class="fa fa-calendar-plus fa-sm" aria-hidden="true"></i> Set Cuti</argon-button>
                <argon-button
                  style="margin-right: 5px; margin-left: 5px;"
                  class="mt-4"
                  variant="gradient"
                  color="success"
                  size="sm"
                  @click="create()"
                ><i class="fa fa-plus fa-sm" aria-hidden="true"></i> Add Periode</argon-button>
                <argon-button
                  class="mt-4"
                  variant="gradient"
                  color="secondary"
                  size="sm"
                  @click="filter()"
                ><i class="fa fa-filter fa-sm" aria-hidden="true"></i> Filter</argon-button>
              </div>
            </div>
            
            <div class="card-body px-0 pt-0 pb-2 mt-4">
              <div class="table-responsive p-0 scroll">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr style="color: white;">
                      <th class="text-uppercase text-xxs font-weight-bolder ">Nama Karyawan</th>
                      <th></th>
                      <th v-for="(row, i) in tableAbsen.data" :key="i" class="text-uppercase text-xxs font-weight-bolder ps-2 text-center" :style="(moment(row.date).locale('id').format('ddd') == 'Sab' || moment(row.date).locale('id').format('ddd') == 'Min') ? 'background-color: red;' : ''">
                        <p class="text-xs font-weight-bold mb-0 text-center">{{moment(row.date).locale('id').format('ddd')}}</p>
                        <p class="text-xs font-weight-bold mb-0 text-center">{{moment(row.date).locale('id').format('DD')}}</p>
                      </th>
                      <th class="text-uppercase text-xxs font-weight-bolder ps-2 text-center" style="background-color: #FF8C00;"><p class="text-xs font-weight-bold mb-0 text-center">S</p></th>
                      <th class="text-uppercase text-xxs font-weight-bolder ps-2 text-center" style="background-color: #FF8C00;"><p class="text-xs font-weight-bold mb-0 text-center">I</p></th>
                      <th class="text-uppercase text-xxs font-weight-bolder ps-2 text-center" style="background-color: #FF8C00;"><p class="text-xs font-weight-bold mb-0 text-center">A</p></th>
                      <th class="text-uppercase text-xxs font-weight-bolder ps-2 text-center" style="background-color: #FF8C00;"><p class="text-xs font-weight-bold mb-0 text-center">C</p></th>
                      <th class="text-uppercase text-xxs font-weight-bolder ps-2 text-center" style="background-color: #FF8C00;"><p class="text-xs font-weight-bold mb-0 text-center">HK</p></th>
                      <th class="text-uppercase text-xxs font-weight-bolder ps-2 text-center" style="background-color: #FF8C00;"><p class="text-xs font-weight-bold mb-0 text-center">OT</p></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, i) in absenKaryawan.data" :key="i" @click="setBg(i)" :style="(backgroundRed == i) ? 'background-color: #5F9EA0; cursor: pointer;' : 'cursor: pointer;' ">
                      <td>
                        <div class="d-flex px-2 py-1">
                          <div class="d-flex flex-column justify-content-center">
                            <h6 class="mb-0 text-sm">{{ row.nama }}</h6>
                            <p class="text-xs text-secondary mb-0">{{ row.unit}}</p>
                          </div>
                        </div>
                      </td>
                      <td>
                        <p class="text-xs font-weight-bold mb-0 text-center" style="background-color: #FFFACD;">HK</p>
                        <p class="text-xs font-weight-bold mb-0 text-center" style="background-color: #7FFF00;">OT</p>
                      </td>
                      <td v-for="(value, j) in row.rel_absen_karyawan" :key="j">
                        <p class="text-xs font-weight-bold mb-0 text-center" :style="(value.type_hk == '0') ? 'background-color: #FF6347;' : (value.type_hk == '') ? 'background-color: #FF6347;' : (value.type_hk == 'S') ? 'background-color: #8FBC8F;' : (value.type_hk == 'L') ? 'background-color: #7FFF00;' : (value.type_hk == 'C') ? 'background-color: yellow;' :'background-color: #FFFACD;'">
                          <input style="border: 1px solid transparent; background: transparent; text-align: center;" size="1" v-model="value.type_hk" @keyup="updateAbsen(value.id, value.type_hk, 'HK', row.unit, moment(value.date).locale('id').format('ddd'))">
                          <!-- {{moment(value.date).locale('id').format('ddd')}} -->
                        </p>
                        <p class="text-xs font-weight-bold mb-0 text-center" :style="(value.type_ot != '0.00') ? 'background-color: #7FFF00;' : (value.type_ot == '')">
                          <input style="border: 1px solid transparent; background: transparent; text-align: center;" size="2" v-model="value.type_ot" @keyup="updateAbsen(value.id, value.type_ot, 'OT', row.unit, moment(value.date).locale('id').format('ddd'))">
                        </p>
                      </td>
                      <td style="background-color: #8FBC8F; text-align: center;">{{row.total_sakit_count}}</td>
                      <td style="background-color: #DCDCDC; text-align: center;">{{row.total_ijin_count}}</td>
                      <td style="background-color: #FF6347; text-align: center;">{{row.total_alpa_count}}</td>
                      <td style="background-color: yellow; text-align: center;">{{row.total_cuti_count}}</td>
                      <td style="background-color: #FFFACD; text-align: center;">{{row.total_kerja_count}}</td>
                      <td style="background-color: #7FFF00; text-align: center;">{{row.total_ot_count}}</td>
                    </tr>
                    <tr>
                      <td :colspan="(absenKaryawan.data.length != 0) ? absenKaryawan.data[0].rel_absen_karyawan.length  + 2 : 0" style="background-color: #F8F8FF; text-align: center;">TOTAL </td>
                      <td style="background-color: #F8F8FF; text-align: center;">{{ totalSakitAll }}</td>
                      <td style="background-color: #F8F8FF; text-align: center;">{{ totalIjinAll }}</td>
                      <td style="background-color: #F8F8FF; text-align: center;">{{ totalAlpaAll }}</td>
                      <td style="background-color: #F8F8FF; text-align: center;">{{ totalCutiAll }}</td>
                      <td style="background-color: #F8F8FF; text-align: center;">{{ totalKerjAll }}</td>
                      <td style="background-color: #7FFF00; text-align: center;">{{ totalOTAll }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card-footer">
              <argon-button
                variant="gradient"
                color="info"
                size="sm"
                @click="cekLembur()"
              ><i class="fa fa-check-square fa-sm" aria-hidden="true" style="margin-right: 5px;"></i> Cek Lembur</argon-button>
            </div>
          </div>
      </div>
    </div>
  </div>

  <!-- ======== ATTENDANCE LOGS ======== -->
  <div class="container-fluid">
    <div class="card">
      <div class="card-header pb-0">
        <div class="d-flex align-items-center">
          <h6>ATTENDANCE LOGS</h6>
          <a class="ms-auto" :href="apiUrl+'export-excel/attendance-logs?nama='+searchAttLog.nama+'&shift='+searchAttLog.shift+'&date_start='+searchAttLog.date_start+'&date_end='+searchAttLog.date_end+'&type='+searchAttLog.type+''" target="_BLANK"><argon-button color="success" size="xs" class="ms-auto" variant="gradient"><i class="fa fa-file-excel-o" aria-hidden="true" style="margin-right: 5px;"></i> Export Excel</argon-button></a>
          <argon-button
            style="margin-left: 5px;"
            variant="gradient"
            color="warning"
            size="sm"
            @click="getAttLog()"
          ><i class="fa fa-refresh fa-sm" aria-hidden="true"></i> Refresh</argon-button>
          <argon-button
            style="margin-left: 5px;"
            variant="gradient"
            color="secondary"
            size="sm"
            @click="filterAttLog()"
          ><i class="fa fa-filter fa-sm" aria-hidden="true"></i> Filter</argon-button>
          <argon-button
            style="margin-left: 5px;"
            variant="gradient"
            color="info"
            size="sm"
            @click="createLog()"
          ><i class="fa fa-plus fa-sm" aria-hidden="true"></i> Add Logs</argon-button>

        </div>
      </div>
      <div class="card-body">
        <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0 scroll scroll-freeze2">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr style="background-color: #F0F8FF;">
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder " style="width: 56px;">NO</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder  ps-2">NAMA</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder  ps-2">JABATAN</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder  ps-2">SHIFT</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">DAY</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">DATE</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">TIME</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">TYPE</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">SOURCE</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder "></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in tableAttLog.data" :key="i">
                    <td class="align-middle text-center text-sm">
                      <span class="text-xs text-secondary font-weight-bold"> {{ i + 1 }} </span>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm"> {{ row.nama }} </h6>
                          <p class="text-xs text-secondary mb-0"> {{ row.pin }} </p>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="text-secondary text-xs font-weight-bold"> {{ row.jabatan }} </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold"> {{row.shift}} </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold"> {{ moment(row.date).locale('id').format('dddd') }} </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold"> {{ moment(row.date).locale('id').format('LL') }} </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold"> {{row.time}} </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="badge badge-sm bg-gradient-info" v-if="row.type == 'Masuk'">{{ row.type }}</span>
                      <span class="badge badge-sm bg-gradient-success" v-else-if="row.type == 'Keluar'">{{ row.type }}</span>
                      <span class="badge badge-sm bg-gradient-danger" v-else>{{ row.type }} {{ row.telat }} Menit</span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="badge badge-sm bg-gradient-dark" v-if="row.source == 'Mobile'"><i class="fas fa-mobile-alt"></i> Mobile</span>
                      <span class="badge badge-sm bg-gradient-secondary" v-else><i class="fas fa-fingerprint"></i> Fingerprint</span>
                    </td>
                    <td>
                      <i class="fas fa-edit fa-sm" aria-hidden="true" style="cursor: pointer; margin-right: 20px;" @click="editAttLogs(row.id)" title="Edit"></i>
                      <i class="fas fa-trash fa-sm" aria-hidden="true" title="Hapus" style="cursor: pointer; margin-right: 20px;" @click="removeAttLog(row.id)"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
      </div>
    </div>
  </div>

  <!-- ======== HISTORY LEMBUR ======== -->
  <div class="container-fluid mt-4">
    <div class="card">
      <div class="card-header pb-0">
        <div class="d-flex align-items-center">
          <h6>HISTORY LEMBUR</h6>
          <a class="ms-auto" style="margin-right: -750px;" :href="apiUrl+'print-pdf/history-spl?nama='+searchHisLembur.nama+'&unit='+searchHisLembur.unit+'&tanggal='+searchHisLembur.tanggal+'&status_approval='+searchHisLembur.status_approval+'&code_spl='+searchHisLembur.code_spl+'&created_by='+searchHisLembur.created_by+''" target="_BLANK"><argon-button color="danger" size="xs" class="ms-auto" variant="gradient"><i class="fa fa-file-excel-o" aria-hidden="true" style="margin-right: 5px;"></i> Print SPL</argon-button></a>
          <a class="ms-auto" :href="apiUrl+'export-excel/history-lembur?nama='+searchHisLembur.nama+'&unit='+searchHisLembur.unit+'&tanggal_start='+searchHisLembur.tanggal_start+'&tanggal_end='+searchHisLembur.tanggal_end+'&status_approval='+searchHisLembur.status_approval+'&code_spl='+searchHisLembur.code_spl+'&created_by='+searchHisLembur.created_by+''" target="_BLANK"><argon-button color="success" size="xs" class="ms-auto" variant="gradient"><i class="fa fa-file-excel-o" aria-hidden="true" style="margin-right: 5px;"></i> Export Excel</argon-button></a>
          <argon-button
            style="margin-left: 5px;"
            variant="gradient"
            color="secondary"
            size="sm"
            @click="filterHisLembur()"
          ><i class="fa fa-filter fa-sm" aria-hidden="true"></i> Filter</argon-button>
          <argon-button
            style="margin-left: 5px;"
            variant="gradient"
            color="info"
            size="sm"
            @click="createLembur()"
          ><i class="fa fa-plus fa-sm" aria-hidden="true"></i> Add Lembur</argon-button>
        </div>
      </div>
      <div class="card-body">
        <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0 scroll scroll-freeze2">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr style="background-color: #F0F8FF;">
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder " style="width: 56px;">NO</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder  ps-2">NAMA</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder  ps-2">HARI</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder  ps-2">Tanggal Lembur</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder  ps-2">AKTUAL JAM</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder  ps-2">KALKULASI JAM</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">STATUS</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">CODE SPL</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">APPROVED BY</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">APPROVED AT</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">CREATED BY</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">CREATED AT</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder "></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in tableHisLembur.data" :key="i">
                    <td class="align-middle text-center text-sm">
                      <span class="text-xs text-secondary font-weight-bold"> {{ i + 1 }} </span>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm"> {{ row.nama }} </h6>
                          <p class="text-xs text-secondary mb-0"> {{ row.unit }} </p>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="text-secondary text-xs font-weight-bold"> {{ moment(row.tanggal).locale('id').format('dddd') }} </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="text-secondary text-xs font-weight-bold"> {{ moment(row.tanggal).locale('id').format('LL') }} </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold"> {{row.actual_jam}} </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold"> {{row.calculate_jam}} </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="badge badge-sm bg-gradient-success" v-if="row.status_approval == 'Approved'"> {{ row.status_approval }} </span>
                      <span class="badge badge-sm bg-gradient-danger" v-if="row.status_approval == 'Not Approved'"> {{ row.status_approval }} </span>
                      <span class="badge badge-sm bg-gradient-warning" v-if="row.status_approval == 'Waiting'"> {{ row.status_approval }} </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="badge badge-sm bg-gradient-info"> {{ row.code_spl }} </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold"> {{row.approved_by}} </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold"> {{ moment(row.approved_date).locale('id').format('LL') }} </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold"> {{row.created_by}} </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold"> {{ moment(row.created_at).locale('id').format('LL') }} </span>
                    </td>
                    <td>
                      <i class="fas fa-edit fa-sm" aria-hidden="true" style="cursor: pointer; margin-right: 20px;" @click="editLembur(row.id)" title="Edit"></i>
                      <i class="fas fa-trash fa-sm" aria-hidden="true" title="Hapus" style="cursor: pointer; margin-right: 20px;" @click="removeLembur(row.id)"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
      </div>
    </div>
  </div>

  <!-- ======== HISTORY CUTI / SAKIT ======== -->
  <div class="container-fluid mt-4">
    <div class="card">
      <div class="card-header pb-0">
        <div class="d-flex align-items-center">
          <h6>HISTORY CUTI / SAKIT</h6>
          <a class="ms-auto" :href="apiUrl+'export-excel/history-lembur?nama='+searchHisLembur.nama+'&tanggal_start='+searchHisLembur.tanggal_start+'&tanggal_end='+searchHisLembur.tanggal_end+'&status_approval='+searchHisLembur.status_approval+'&code_spl='+searchHisLembur.code_spl+'&created_by='+searchHisLembur.created_by+''" target="_BLANK"><argon-button color="success" size="xs" class="ms-auto" variant="gradient"><i class="fa fa-file-excel-o" aria-hidden="true" style="margin-right: 5px;"></i> Export Excel</argon-button></a>
          <argon-button
            style="margin-left: 5px;"
            variant="gradient"
            color="secondary"
            size="sm"
            @click="filterHisCuti()"
          ><i class="fa fa-filter fa-sm" aria-hidden="true"></i> Filter</argon-button>
          <argon-button
            style="margin-left: 5px;"
            variant="gradient"
            color="info"
            size="sm"
            @click="createCuti()"
          ><i class="fa fa-plus fa-sm" aria-hidden="true"></i> Add Cuti / Izin</argon-button>

        </div>
      </div>
      <div class="card-body">
        <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0 scroll scroll-freeze2">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr style="background-color: #F0F8FF;">
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder " style="width: 56px;">NO</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder  ps-2">DIBUAT OLEH</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder  ps-2">ALASAN</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder  ps-2">DARI TANGAL</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder  ps-2">SAMPAI TANGAL</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder  ps-2">TOTAL HARI</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">BUKTI</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">STATUS</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">TYPE</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">APPROVED BY</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">APPROVED AT</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ">CREATED AT</th>
                    <th class="text-center text-uppercase text-white text-xxs font-weight-bolder "></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in tableHisCuti.data" :key="i">
                    <td class="align-middle text-center text-sm">
                      <span class="text-xs text-secondary font-weight-bold"> {{ i + 1 }} </span>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm"> {{ row.dibuat_oleh }} </h6>
                          <p class="text-xs text-secondary mb-0"> {{ row.id_karyawan }} </p>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold"> {{row.alasan_cuti}} </span>
                    </td>
                    <!-- <td class="align-middle text-center text-sm">
                      <span class="text-secondary text-xs font-weight-bold"> {{ moment(row.tanggal).locale('id').format('dddd') }} </span>
                    </td> -->
                    <td class="align-middle text-center text-sm">
                      <span class="text-secondary text-xs font-weight-bold"> {{ moment(row.dari_tanggal).locale('id').format('LL') }} </span>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span class="text-secondary text-xs font-weight-bold"> {{ moment(row.sampai_tanggal).locale('id').format('LL') }} </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold"> {{row.total_day}} </span>
                    </td>
                    <td class="align-middle text-center">
                      <a v-if="row.bukti" :href="storageUrl+'/foto_bukti_sakit/'+row.bukti" target="_BLANK" class="text-xs font-weight-bold text-primary">
                        Bukti Surat Sakit
                      </a>
                    </td>
                    <td class="align-middle text-center">
                      <span class="badge badge-sm bg-gradient-success" v-if="row.status_approval == 'Approved'"> {{ row.status_approval }} </span>
                      <span class="badge badge-sm bg-gradient-danger" v-if="row.status_approval == 'Not Approved'"> {{ row.status_approval }} </span>
                      <span class="badge badge-sm bg-gradient-warning" v-if="row.status_approval == 'Waiting'"> {{ row.status_approval }} </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="badge badge-sm bg-gradient-info" v-if="row.type == 'Cuti'"> {{ row.type }} </span>
                      <span class="badge badge-sm bg-gradient-danger" v-if="row.type == 'Sakit'"> {{ row.type }} </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold"> {{row.approved_by}} </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold"> {{ moment(row.approved_date).locale('id').format('LL') }} </span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold"> {{ moment(row.created_at).locale('id').format('LL') }} </span>
                    </td>
                    <td>
                      <i class="fas fa-edit fa-sm" aria-hidden="true" style="cursor: pointer; margin-right: 20px;" @click="editCuti(row.id)" title="Edit"></i>
                      <i class="fas fa-trash fa-sm" aria-hidden="true" title="Hapus" style="cursor: pointer; margin-right: 20px;" @click="removeCuti(row.id)"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
      </div>
    </div>
  </div>

  <!-- =======  MODAL CREATE ======= -->
  <div class="container">
    <vue-final-modal v-model="form.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{form.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="form.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <!-- <label for="example-text-input" class="form-control-label">ID Karyawan <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="ID Karyawan" v-model="karyawan.id_karyawan">
        <label for="example-text-input" class="form-control-label">Nama <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Nama" v-model="karyawan.nama" required>
        <label for="example-text-input" class="form-control-label">Type</label>
        <select class="form-select" aria-label="Default select example" v-model="karyawan.type">
          <option selected>Type</option>
          <option value="HK">Masuk</option>
          <option value="A">Alpa</option>
          <option value="S">Sakit</option>
          <option value="I">Ijin</option>
          <option value="C">Cuti</option>
        </select> -->
        <label for="example-text-input" class="form-control-label">Periode <span style="color: red;">*</span></label>
        <input type="month" class="form-control" v-model="karyawan.periode" @change="onPeriodeCreateChange()" required>
      </div>
      <!-- footer -->
      <div class="row float-right mt-5">
        <div class="col-6"> 
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="form.show = false">Close</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="save()" :disabled="onLoading == true">
            <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
            <span v-else>
                <span> Save</span>
            </span>
          </argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

   <!-- =======  MODAL FILTER ======= -->
  <div class="container">
    <vue-final-modal v-model="formFilter.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formFilter.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formFilter.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label">Nama <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Nama" v-model="search.nama" required>
        <label for="example-text-input" class="form-control-label mt-3">Periode <span style="color: red;">*</span></label>
        <input type="month" class="form-control" v-model="search.periode" @change="onPeriodeFilterChange()" required>
      </div>
      <!-- footer -->
      <div class="row float-right mt-5">
        <div class="col-6">
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="formFilter.show = false">Close</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="getAbsen()" :disabled="onLoading == true">
            <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
            <span v-else>
                <span> Filter</span>
            </span>
          </argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

   <!-- =======  MODAL SET LIBUR ======= -->
  <div class="container">
    <vue-final-modal v-model="formLibur.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formLibur.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formLibur.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label">Set Tanggal <span style="color: red;">*</span></label>
        <input type="date" class="form-control" placeholder="Nama" v-model="setDataLibur.tanggal" required>
      </div>
      <!-- footer -->
      <div class="row float-right mt-5">
        <div class="col-6"> 
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="formLibur.show = false">Close</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="setLiburGo()" :disabled="onLoading == true">
            <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
            <span v-else>
                <span> Save</span>
            </span>
          </argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

   <!-- =======  MODAL SET CUTI BERSAMA (SEMUA KARYAWAN) ======= -->
  <div class="container">
    <vue-final-modal v-model="formSetCuti.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formSetCuti.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formSetCuti.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <p class="text-xs text-secondary">Menandai Cuti untuk <b>SEMUA KARYAWAN</b> pada rentang tanggal ini, dan ikut mengurangi jatah cuti tahunan masing-masing karyawan.</p>
        <label for="example-text-input" class="form-control-label mt-3">Dari Tanggal <span style="color: red;">*</span></label>
        <input type="date" class="form-control" v-model="dataSetCuti.dari_tanggal" required>
        <label for="example-text-input" class="form-control-label mt-3">Sampai Tanggal <span style="color: red;">*</span></label>
        <input type="date" class="form-control" v-model="dataSetCuti.sampai_tanggal" required>
        <label for="example-text-input" class="form-control-label mt-3">Alasan (opsional)</label>
        <input type="text" class="form-control" placeholder="Cuti Bersama" v-model="dataSetCuti.alasan_cuti">
      </div>
      <!-- footer -->
      <div class="row float-right mt-5">
        <div class="col-6">
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="formSetCuti.show = false">Close</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="setCutiBersamaGo()" :disabled="onLoading == true">
            <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
            <span v-else>
                <span> Save</span>
            </span>
          </argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

  <!-- =======  MODAL FILTER ATT LOG ======= -->
  <div class="container">
    <vue-final-modal v-model="formFilterAttLog.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formFilterAttLog.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formFilterAttLog.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label">Nama</label>
        <input type="text" class="form-control" placeholder="Nama" v-model="searchAttLog.nama">
        <label for="example-text-input" class="form-control-label mt-3">Shift</label>
        <select class="form-select" aria-label="Default select example" v-model="searchAttLog.shift">
          <option selected>Shift</option>
          <option value="Non">Non</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Date Range</label>
        <date-range-picker v-model:start-date="searchAttLog.date_start" v-model:end-date="searchAttLog.date_end" />
        <label for="example-text-input" class="form-control-label mt-3">Type</label>
        <select class="form-select" aria-label="Default select example" v-model="searchAttLog.type">
          <option selected>Type</option>
          <option value="Masuk">Masuk</option>
          <option value="Keluar">Keluar</option>
        </select>
      </div>
      <!-- footer -->
      <div class="row float-right mt-5">
        <div class="col-6"> 
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="formFilterAttLog.show = false">Close</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="getAttLog()" :disabled="onLoading == true">
            <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
            <span v-else>
                <span> Filter</span>
            </span>
          </argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

   <!-- =======  MODAL FILTER HISTORY LEMBUR ======= -->
  <div class="container">
    <vue-final-modal v-model="formFilterHisLembur.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formFilterHisLembur.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formFilterHisLembur.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label">Nama</label>
        <input type="text" class="form-control" placeholder="Nama" v-model="searchHisLembur.nama">
        <label for="example-text-input" class="form-control-label mt-3">Unit</label>
        <select class="form-select" aria-label="Default select example" v-model="searchHisLembur.unit">
          <option value="Head Quarter">Head Quarter</option>
          <option value="Fabrikasi">Fabrikasi</option>
          <option value="Unit Pipa">Unit Pipa</option>
          <option value="Unit Slitting">Unit Slitting</option>
          <option value="Unit Shearing">Unit Shearing</option>
          <option value="Unit Maintenance">Unit Maintenance</option>
          <option value="Unit House Keeping">Unit House Keeping</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Tanggal Lembur</label>
        <date-range-picker v-model:start-date="searchHisLembur.tanggal_start" v-model:end-date="searchHisLembur.tanggal_end" />
        <label for="example-text-input" class="form-control-label mt-3">Approval Status</label>
        <select class="form-select" aria-label="Default select example" v-model="searchHisLembur.status_approval">
          <option selected>Select Status</option>
          <option value="Approved">Approved</option>
          <option value="Not Approved">Not Approved</option>
          <option value="Waiting">Waiting</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Code SPL</label>
        <input type="text" class="form-control" placeholder="Code SPL" v-model="searchHisLembur.code_spl">
        <label for="example-text-input" class="form-control-label">Di Buat Oleh</label>
        <input type="text" class="form-control" placeholder="Di Buat Oleh" v-model="searchHisLembur.created_by">
      </div>
      <!-- footer -->
      <div class="row float-right mt-5">
        <div class="col-6"> 
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="formFilterHisLembur.show = false">Close</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="getHisLembur()" :disabled="onLoading == true">
            <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
            <span v-else>
                <span> Filter</span>
            </span>
          </argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

   <!-- =======  MODAL FILTER HISTORY CUTI / IZIN ======= -->
  <div class="container">
    <vue-final-modal v-model="formFilterHisCuti.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formFilterHisCuti.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formFilterHisCuti.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label">DIbuat Oleh</label>
        <input type="text" class="form-control" placeholder="DIbuat Oleh" v-model="searchHisCuti.dibuat_oleh">
        <label for="example-text-input" class="form-control-label mt-3">Tanggal</label>
        <date-range-picker v-model:start-date="searchHisCuti.tanggal_start" v-model:end-date="searchHisCuti.tanggal_end" />
        <label for="example-text-input" class="form-control-label mt-3">Type</label>
        <select class="form-select" aria-label="Default select example" v-model="searchHisCuti.type">
          <option selected>Select Status</option>
          <option value="Cuti">Cuti</option>
          <option value="Sakit">Sakit</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Approval Status</label>
        <select class="form-select" aria-label="Default select example" v-model="searchHisCuti.status_approval">
          <option selected>Select Status</option>
          <option value="Approved">Approved</option>
          <option value="Not Approved">Not Approved</option>
          <option value="Waiting">Waiting</option>
        </select>
      </div>
      <!-- footer -->
      <div class="row float-right mt-5">
        <div class="col-6"> 
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="formFilterHisCuti.show = false">Close</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="getHisCuti()" :disabled="onLoading == true">
            <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
            <span v-else>
                <span> Filter</span>
            </span>
          </argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

  <!-- =======  MODAL EDIT ATT LOGS ======= -->
  <div class="container">
    <vue-final-modal v-model="formEditAttLogs.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formEditAttLogs.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formEditAttLogs.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3">ID Karyawan</label>
        <karyawan-search-select v-if="formEditAttLogs.title == 'Add Data Att Logs'" v-model="dataAttLogs.pin" />
        <input type="text" class="form-control" placeholder="Nama" v-model="dataAttLogs.pin" v-else>
        <label for="example-text-input" class="form-control-label mt-3">Shift</label>
        <select class="form-select" aria-label="Default select example" v-model="dataAttLogs.shift">
          <option selected>Shift</option>
          <option value="Non">Non</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
        </select>
        <label for="example-text-input" class="form-control-label mt-3">Date</label>
        <input type="date" class="form-control" placeholder="Nama" v-model="dataAttLogs.date">
        <label for="example-text-input" class="form-control-label mt-3">Time</label>
        <input type="time" class="form-control" placeholder="Nama" v-model="dataAttLogs.time">
        <label for="example-text-input" class="form-control-label mt-3">Type</label>
        <select class="form-select" aria-label="Default select example" v-model="dataAttLogs.type">
          <option selected>Type</option>
          <option value="Masuk">Masuk</option>
          <option value="Keluar">Keluar</option>
        </select>
      </div>
      <!-- footer -->
      <div class="row float-right mt-5">
        <div class="col-6"> 
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="formEditAttLogs.show = false">Close</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="saveAttLogs()" :disabled="onLoading == true">
            <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
            <span v-else>
                <span> Save</span>
            </span>
          </argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

   <!-- =======  MODAL EDIT LEMBUR ======= -->
  <div class="container">
    <vue-final-modal v-model="formEditLembur.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formEditLembur.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formEditLembur.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <template v-if="formEditLembur.title == 'Add Data Lembur'">
          <label for="example-text-input" class="form-control-label mt-3">Id Karyawan <span style="color: red;">*</span></label>
          <karyawan-search-select v-model="dataLembur.id_karyawan" />
          <label for="example-text-input" class="form-control-label mt-3">Tanggal <span style="color: red;">*</span></label>
          <input type="date" class="form-control" placeholder="Tanggal" v-model="dataLembur.tanggal">
          <label for="example-text-input" class="form-control-label mt-3">Aktual Jam <span style="color: red;">*</span></label>
          <input type="number" class="form-control" placeholder="Aktual Jam" v-model="dataLembur.actual_jam">
          <label for="example-text-input" class="form-control-label mt-3">Uraian Pekerjaan <span style="color: red;">*</span></label>
          <input type="text" class="form-control" placeholder="Uraian Pekerjaan" v-model="dataLembur.uraian_pekerjaan">
          <label for="example-text-input" class="form-control-label mt-3">Status <span style="color: red;">*</span></label>
          <select class="form-select" v-model="dataLembur.status_approval">
            <option value="Waiting">Waiting</option>
            <option value="Approved">Approved</option>
            <option value="Not Approved">Not Approved</option>
          </select>
        </template>
        <template v-else>
          <label for="example-text-input" class="form-control-label mt-3">Code SPL</label>
          <input type="text" class="form-control" placeholder="Code SPL" v-model="dataLembur.code_spl" disabled>
          <label for="example-text-input" class="form-control-label mt-3">Nama</label>
          <input type="text" class="form-control" placeholder="Code SPL" v-model="dataLembur.nama" disabled>
          <label for="example-text-input" class="form-control-label mt-3">Tanggal</label>
          <input type="date" class="form-control" placeholder="Tanggal" v-model="dataLembur.tanggal" disabled>
          <label for="example-text-input" class="form-control-label mt-3">Aktual Jam</label>
          <input type="number" class="form-control" placeholder="Aktual Jam" v-model="dataLembur.actual_jam">
          <label for="example-text-input" class="form-control-label mt-3">Uraian Pekerjaan</label>
          <input type="text" class="form-control" placeholder="Uraian Pekerjaan" v-model="dataLembur.uraian_pekerjaan" disabled>
        </template>
      </div>
      <!-- footer -->
      <div class="row float-right mt-5">
        <div class="col-6"> 
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="formEditLembur.show = false">Close</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="saveLembur()" :disabled="onLoading == true">
            <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
            <span v-else>
                <span> Save</span>
            </span>
          </argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

  <!-- =======  MODAL EDIT CUTI ======= -->
  <div class="container">
    <vue-final-modal v-model="formEditCuti.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formEditCuti.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formEditCuti.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <label for="example-text-input" class="form-control-label mt-3" v-if="formEditCuti.title == 'Edit Data Cuti'">Dibuat Oleh</label>
        <input type="text" class="form-control" placeholder="Dibuat Oleh" v-model="dataCuti.dibuat_oleh" v-if="formEditCuti.title == 'Edit Data Cuti'">
        <label for="example-text-input" class="form-control-label mt-3" v-if="formEditCuti.title == 'Add Data Cuti / Izin'">Id Karyawan <span style="color: red;">*</span></label>
        <karyawan-search-select v-model="dataCuti.id_karyawan" v-if="formEditCuti.title == 'Add Data Cuti / Izin'" />
        <label for="example-text-input" class="form-control-label mt-3">Alasan <span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Alasan" v-model="dataCuti.alasan_cuti" :disabled="formEditCuti.title == 'Edit Data Cuti'">
        <label for="example-text-input" class="form-control-label mt-3">Dari Tanggal <span style="color: red;">*</span></label>
        <input type="date" class="form-control" placeholder="Dari Tanggal" v-model="dataCuti.dari_tanggal">
        <label for="example-text-input" class="form-control-label mt-3">Sampai Tanggal <span style="color: red;">*</span></label>
        <input type="date" class="form-control" placeholder="Sampai Tanggal" v-model="dataCuti.sampai_tanggal">
        <label for="example-text-input" class="form-control-label mt-3">Type <span style="color: red;">*</span></label>
        <select class="form-select" aria-label="Default select example" v-model="dataCuti.type">
          <option selected>Type</option>
          <option value="Cuti">Cuti</option>
          <option value="Sakit">Sakit</option>
        </select>
        <template v-if="dataCuti.type == 'Sakit' && formEditCuti.title == 'Add Data Cuti / Izin'">
          <label for="example-text-input" class="form-control-label mt-3">Surat Sakit <span style="color: red;">*</span></label>
          <input type="file" class="form-control" accept="image/*,.pdf" @change="filesChangeCuti">
          <p class="text-xs text-secondary mt-1 mb-0">Wajib diisi untuk pengajuan Sakit.</p>
        </template>
        <label for="example-text-input" class="form-control-label mt-3">Status <span style="color: red;">*</span></label>
        <select class="form-select" aria-label="Default select example" v-model="dataCuti.status_approval">
          <option selected>Status</option>
          <option value="Approved">Approved</option>
          <option value="Not Approved">Not Approved</option>
          <option value="Waiting">Waiting</option>
        </select>
      </div>
      <!-- footer -->
      <div class="row float-right mt-5">
        <div class="col-6"> 
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="formEditCuti.show = false">Close</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="saveCuti()" :disabled="onLoading == true">
            <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
            <span v-else>
                <span> Save</span>
            </span>
          </argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

   <!-- =======  MODAL CEK LEMBUR OTOMATIS ======= -->
  <div class="container">
    <vue-final-modal v-model="formCekLembur.show" classes="modal-container" content-class="modal-content-width" :z-index="10000">
      <!-- header -->
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{formCekLembur.title}}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formCekLembur.show = false"></i>
        </div>
      </div><hr>
      <!-- end header -->
      <div class="modal__content container">
        <p class="text-xs text-secondary">
          Membandingkan jam SPL lembur dengan jam kehadiran aktual untuk periode <strong>{{ moment(search.periode_start).locale('id').format('D MMMM') }} - {{ moment(search.periode_end).locale('id').format('D MMMM YYYY') }}</strong>.
          SPL yang tidak ada kehadirannya akan otomatis ditolak. SPL disetujui dengan kehadiran di hari libur akan ditandai "L". Hasil ini hanya preview, belum ada yang berubah sampai Anda klik "Terapkan" -- dan hanya baris yang tercentang yang akan diproses.
          Kolom <strong>Jam SPL</strong> adalah jam yang diajukan karyawan dan <strong>tidak pernah diubah</strong> oleh fitur ini -- "Terapkan" hanya menyesuaikan jam yang dipakai untuk perhitungan gaji saat Jam SPL melebihi Jam Aktual.
        </p>
        <argon-button variant="gradient" color="info" size="sm" @click="cekLemburPreview()" :disabled="onLoadingCekLembur == true">
          <span v-if="onLoadingCekLembur"><i class="fa fa-spinner fa-spin"></i> Memeriksa...</span>
          <span v-else><i class="fa fa-sync-alt fa-sm" aria-hidden="true"></i> Cek Ulang</span>
        </argon-button>

        <div v-if="tableCekLembur.data.length > 0" class="mt-3">
          <p class="text-sm">
            <span class="badge badge-sm bg-gradient-success">{{ cekLemburSesuaiCount }} Sesuai</span>
            <span class="badge badge-sm bg-gradient-warning ms-1">{{ cekLemburTidakSesuaiCount }} Tidak Sesuai</span>
            <span class="badge badge-sm bg-gradient-info ms-1">{{ cekLemburSudahDikoreksiCount }} Sudah Dikoreksi</span>
            <span class="badge badge-sm bg-gradient-danger ms-1">{{ cekLemburRejectCount }} Tidak Ada Kehadiran (Akan Ditolak)</span>
          </p>
          <div class="row">
            <div class="col-4">
              <input type="text" class="form-control form-control-sm" placeholder="Cari Nama" v-model="filterCekLembur.nama">
            </div>
            <div class="col-4">
              <select class="form-select form-select-sm" v-model="filterCekLembur.unit">
                <option value="">Semua Unit</option>
                <option value="Head Quarter">Head Quarter</option>
                <option value="Fabrikasi">Fabrikasi</option>
                <option value="Unit Pipa">Unit Pipa</option>
                <option value="Unit Slitting">Unit Slitting</option>
                <option value="Unit Shearing">Unit Shearing</option>
                <option value="Unit Maintenance">Unit Maintenance</option>
                <option value="Unit House Keeping">Unit House Keeping</option>
              </select>
            </div>
            <div class="col-4">
              <select class="form-select form-select-sm" v-model="filterCekLembur.status_cek">
                <option value="perlu_perhatian">Perlu Perhatian (Bukan Sesuai)</option>
                <option value="">Semua Hasil Cek</option>
                <option value="Tidak Sesuai">Tidak Sesuai</option>
                <option value="Sudah Dikoreksi">Sudah Dikoreksi</option>
                <option value="Sesuai">Sesuai</option>
                <option value="Tidak Ada Kehadiran">Tidak Ada Kehadiran</option>
              </select>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-8">
              <date-range-picker v-model:start-date="filterCekLembur.tanggal_start" v-model:end-date="filterCekLembur.tanggal_end" />
            </div>
            <div class="col-1">
              <argon-button variant="gradient" color="secondary" size="sm" @click="filterCekLembur = { nama: '', tanggal_start: '', tanggal_end: '', unit: '', status_cek: 'perlu_perhatian' }" title="Reset Filter"><i class="fa fa-sync-alt fa-sm" aria-hidden="true"></i></argon-button>
            </div>
          </div>
          <p class="text-xs text-secondary mt-2 mb-0">
            <i class="fa fa-info-circle" aria-hidden="true"></i>
            "Terapkan" cuma berlaku untuk baris yang tercentang <strong>dan</strong> sesuai filter di atas ({{ selectedFilteredCekLembur.length }} dari {{ filteredCekLembur.length }} baris yang tampil saat ini).
          </p>
          <div class="table-responsive p-0 scroll mt-2" style="height: 60vh;">
            <table class="table align-items-center mb-0">
              <thead>
                <tr style="background-color: #F0F8FF;">
                  <th class="text-start text-uppercase text-white text-xxs font-weight-bolder ps-2">Nama</th>
                  <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ps-2">Tanggal</th>
                  <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ps-2">Status SPL</th>
                  <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ps-2">Shift</th>
                  <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ps-2">Clock In</th>
                  <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ps-2">Clock Out</th>
                  <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ps-2">Jam SPL</th>
                  <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ps-2">Jam Aktual</th>
                  <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ps-2">Selisih</th>
                  <th class="text-center text-uppercase text-white text-xxs font-weight-bolder ps-2">Hasil Cek</th>
                  <th class="text-center ps-2" style="width: 36px;">
                    <input type="checkbox" :checked="allVisibleCekLemburSelected" @change="toggleAllVisibleCekLembur($event.target.checked)" title="Pilih/batalkan semua yang tampil">
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="filteredCekLembur.length == 0">
                  <td colspan="11" class="text-center text-sm text-secondary py-3">Tidak ada hasil yang cocok dengan filter.</td>
                </tr>
                <tr v-for="(row, i) in filteredCekLembur" :key="i">
                  <td class="align-middle text-start text-sm ps-2">
                    <span class="text-secondary text-xs font-weight-bold">{{ row.nama }}</span>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <span class="text-secondary text-xs">{{ moment(row.tanggal).locale('id').format('dd, D MMM YYYY') }}</span>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <span class="text-secondary text-xs">{{ row.status_approval }}</span>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <span class="text-secondary text-xs">{{ row.shift }}</span>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <span class="text-secondary text-xs">{{ row.jam_masuk_aktual != undefined ? row.jam_masuk_aktual.substring(0,5) : '-' }}</span>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <span class="text-secondary text-xs">{{ row.jam_keluar_aktual != undefined ? row.jam_keluar_aktual.substring(0,5) : '-' }}</span>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <span class="text-secondary text-xs font-weight-bold">{{ row.actual_jam_spl }}</span>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <span class="text-secondary text-xs font-weight-bold" v-if="row.actual_menit_aktual != undefined">
                      {{ formatJamMenit(row.actual_menit_aktual) }} <span class="text-secondary fw-normal">({{ row.actual_jam_aktual }} jam)</span>
                    </span>
                    <span class="text-secondary text-xs" v-else>-</span>
                  </td>
                  <td class="align-middle text-center text-sm">
                    <span v-if="row.selisih_menit == undefined" class="text-secondary text-xs">-</span>
                    <span v-else-if="row.selisih_menit == 0" class="text-secondary text-xs">Pas, 0 menit</span>
                    <span v-else-if="row.selisih_menit > 0" class="text-warning text-xs font-weight-bold">Kurang {{ row.selisih_menit }} menit</span>
                    <span v-else class="text-info text-xs font-weight-bold">Kelebihan {{ Math.abs(row.selisih_menit) }} menit</span>
                  </td>
                  <td class="align-middle text-center">
                    <span class="badge badge-sm bg-gradient-success" v-if="row.status_cek == 'Sesuai'">
                      Sesuai
                      <i v-if="row.keterangan_sesuai" class="fa fa-info-circle ms-1" :title="row.keterangan_sesuai" style="cursor: help;"></i>
                    </span>
                    <span class="badge badge-sm bg-gradient-warning" v-else-if="row.status_cek == 'Tidak Sesuai'">Tidak Sesuai</span>
                    <span class="badge badge-sm bg-gradient-info" v-else-if="row.status_cek == 'Sudah Dikoreksi'">Sudah Dikoreksi</span>
                    <span class="badge badge-sm bg-gradient-danger" v-else>Tidak Ada Kehadiran</span>
                    <br v-if="row.perlu_set_libur">
                    <span v-if="row.perlu_set_libur" class="badge badge-sm bg-gradient-dark mt-1" title="Hari libur yang dikerjakan -- kode absensi akan diubah ke 'L' saat diterapkan">Perlu Set "L"</span>
                  </td>
                  <td class="align-middle text-center">
                    <input type="checkbox" v-model="row.selected">
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <p class="text-sm text-secondary mt-3" v-else-if="cekLemburSudahDicek">Tidak ada SPL Waiting/Approved di periode ini.</p>
      </div>
      <!-- footer -->
      <div class="row float-right mt-3">
        <div class="col-6">
        </div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button  variant="gradient" color="secondary" size="sm" width="1" @click="formCekLembur.show = false">Close</argon-button>
        </div>
        <div class="col-3" v-if="tableCekLembur.data.length > 0">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="applyCekLembur()" :disabled="onLoadingCekLembur == true || selectedFilteredCekLembur.length == 0">Terapkan ({{ selectedFilteredCekLembur.length }})</argon-button>
        </div>
      </div>
      <!-- end footer -->
    </vue-final-modal>
   </div>

</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import { VueFinalModal } from 'vue-final-modal'
import Api from '@/helpers/api';
import config from '@/configs/config';
// import dataKaryawan from '@/services/dataKaryawan.service';
var moment = require('moment');
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import dataAbsensi from '@/services/dataAbsensi.service';
import akun from '@/services/akun.service';
import attendanceLog from '@/services/attendanceLog.service';
import approvalLembur from '@/services/approvalLembur.service';
import approvalCuti from '@/services/approvalCuti.service';
import KaryawanSearchSelect from '@/components/KaryawanSearchSelect.vue';
import DateRangePicker from '@/components/DateRangePicker.vue';
import { periodeToRange, defaultPeriode } from '@/helpers/periode';

export default {
  name: "tables",
  components: {
    ArgonButton,
    VueFinalModal,
    KaryawanSearchSelect,
    DateRangePicker,
  },
  data() {
    return {
      moment:moment,
      onLoading: false,
      absenKaryawan: {
        data: []
      },
      tableAbsen: {
        data: []
      },
      tableAttLog: {
        data: []
      },
      tableHisLembur: {
        data: []
      },
      tableHisCuti: {
        data: []
      },
      form: {
        add: true,
        title: "Create Periode Absensi",
        show: false
      },
      formLibur: {
        add: true,
        title: "Set Tanggal Libur / Tanggal Merah",
        show: false
      },
      formSetCuti: {
        title: "Set Cuti Bersama (Semua Karyawan)",
        show: false
      },
      dataSetCuti: {},
      formFilter: {
        add: true,
        title: "Filter",
        show: false
      },
      formFilterAttLog: {
        add: true,
        title: "Filter Att Log",
        show: false
      },
      formFilterHisLembur: {
        add: true,
        title: "Filter History Lembur",
        show: false
      },
      formCekLembur: {
        title: "Cek Lembur Otomatis",
        show: false
      },
      tableCekLembur: {
        data: []
      },
      filterCekLembur: {
        nama: '',
        tanggal_start: '',
        tanggal_end: '',
        unit: '',
        status_cek: 'perlu_perhatian',
      },
      onLoadingCekLembur: false,
      cekLemburSudahDicek: false,
      formFilterHisCuti: {
        add: true,
        title: "Filter History Lembur",
        show: false
      },
      formEditAttLogs: {
        add: true,
        title: "Edit Data Att Logs",
        show: false
      },
      formEditLembur: {
        add: true,
        title: "Edit Data Lembur",
        show: false
      },
      formEditCuti: {
        add: true,
        title: "Edit Data Cuti",
        show: false
      },
      karyawan: {},
      totalSakitAll: '',
      totalIjinAll: '',
      totalAlpaAll: '',
      totalCutiAll: '',
      totalKerjAll: '',
      totalOTAll: '',
      search: {
        nama: '',
        periode: '',
        periode_start: '',
        periode_end: '',
      },
      searchAttLog: {
        nama: '',
        shift: '',
        date_start: '',
        date_end: '',
        type: '',
      },
      searchHisLembur: {
        nama: '',
        unit: '',
        tanggal_start: '',
        tanggal_end: '',
        code_spl: '',
        created_by: '',
        status_approval: '',
      },
      searchHisCuti: {
        dibuat_oleh: '',
        tanggal_start: '',
        tanggal_end: '',
        type: '',
        status_approval: '',
      },
      setDataLibur: {},
      dataAttLogs: {},
      dataLembur: {},
      dataCuti: {},
      backgroundRed: null,
      apiUrl :config.apiUrl,
      storageUrl : config.storageUrl,
      role: '',
    };
  },
  computed: {
    filteredCekLembur() {
      let context = this;
      return this.tableCekLembur.data.filter(function(r) {
        if (context.filterCekLembur.nama && !(r.nama || '').toLowerCase().includes(context.filterCekLembur.nama.toLowerCase())) {
          return false;
        }
        if (context.filterCekLembur.tanggal_start && r.tanggal < context.filterCekLembur.tanggal_start) {
          return false;
        }
        if (context.filterCekLembur.tanggal_end && r.tanggal > context.filterCekLembur.tanggal_end) {
          return false;
        }
        if (context.filterCekLembur.unit && r.unit != context.filterCekLembur.unit) {
          return false;
        }
        if (context.filterCekLembur.status_cek == 'perlu_perhatian' && r.status_cek == 'Sesuai' && !r.perlu_set_libur) {
          return false;
        } else if (context.filterCekLembur.status_cek && context.filterCekLembur.status_cek != 'perlu_perhatian' && r.status_cek != context.filterCekLembur.status_cek) {
          return false;
        }
        return true;
      });
    },
    // Badge counts ignore the Hasil Cek filter itself (nama/tanggal/unit
    // still apply) -- otherwise, with the default filter hiding "Sesuai"
    // rows, the "Sesuai" badge would always read 0 no matter how many
    // there actually are.
    cekLemburByOtherFilters() {
      let context = this;
      return this.tableCekLembur.data.filter(function(r) {
        if (context.filterCekLembur.nama && !(r.nama || '').toLowerCase().includes(context.filterCekLembur.nama.toLowerCase())) {
          return false;
        }
        if (context.filterCekLembur.tanggal_start && r.tanggal < context.filterCekLembur.tanggal_start) {
          return false;
        }
        if (context.filterCekLembur.tanggal_end && r.tanggal > context.filterCekLembur.tanggal_end) {
          return false;
        }
        if (context.filterCekLembur.unit && r.unit != context.filterCekLembur.unit) {
          return false;
        }
        return true;
      });
    },
    cekLemburSesuaiCount() {
      return this.cekLemburByOtherFilters.filter(function(r) { return r.status_cek == 'Sesuai'; }).length;
    },
    cekLemburTidakSesuaiCount() {
      return this.cekLemburByOtherFilters.filter(function(r) { return r.status_cek == 'Tidak Sesuai'; }).length;
    },
    cekLemburSudahDikoreksiCount() {
      return this.cekLemburByOtherFilters.filter(function(r) { return r.status_cek == 'Sudah Dikoreksi'; }).length;
    },
    cekLemburRejectCount() {
      return this.cekLemburByOtherFilters.filter(function(r) { return r.status_cek == 'Tidak Ada Kehadiran'; }).length;
    },
    // What "Terapkan" actually sends -- the intersection of the active
    // filter (nama/tanggal/unit) and each row's own checkbox, so Admin
    // can both narrow by filter AND uncheck individual exceptions within
    // that filtered set.
    selectedFilteredCekLembur() {
      return this.filteredCekLembur.filter(function(r) { return r.selected; });
    },
    allVisibleCekLemburSelected() {
      return this.filteredCekLembur.length > 0 && this.filteredCekLembur.every(function(r) { return r.selected; });
    },
  },
  mounted(){
    // this.get();
    this.getAbsen();
    this.getAttLog();
    this.getHisLembur();
    this.getHisCuti();
    this.tokenApi = 'Bearer '+localStorage.getItem('token');
    this.getRole();
  },
  methods: {
    // get(){
    //   let context = this;               
    //   Api(context, dataKaryawan.index({search: this.search})).onSuccess(function(response) {    
    //       context.table.data = response.data.data.data.data;
    //   }).onError(function(error) {                    
    //       if (error.response.status == 404) {
    //           context.table.data = [];
    //       }
    //   })
    //   .call()
    // },
    getAbsen(){
      let context = this;    
      this.onLoading = true;

      Api(context, dataAbsensi.index({nama: context.search.nama, periode_start: context.search.periode_start, periode_end: context.search.periode_end})).onSuccess(function(response) {
          context.tableAbsen.data    = response.data.data.data;
          context.absenKaryawan.data = response.data.data.absenKaryawan;

          context.search.periode_start = response.data.data.periode_start;
          context.search.periode_end   = response.data.data.periode_end;

          context.totalSakitAll = response.data.data.totalSakitAll;
          context.totalIjinAll  = response.data.data.totalIjinAll;
          context.totalAlpaAll  = response.data.data.totalAlpaAll;
          context.totalCutiAll  = response.data.data.totalCutiAll;
          context.totalKerjAll  = response.data.data.totalKerjAll;
          context.totalOTAll    = response.data.data.totalOTAll;
          context.notify('Data Retrieved Successfully', 'success')
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.table.data = [];
          }
          context.notify('Data Retrieved Failed', 'error')
      }).onFinish(function() { 
         context.onLoading = false;
         context.formFilter.show  = false;
      })
      .call()
    },
    getAttLog(){
      let context = this;    
      this.onLoading = true;

      Api(context, dataAbsensi.attLog({nama: context.searchAttLog.nama, shift: context.searchAttLog.shift, date_start: context.searchAttLog.date_start, date_end: context.searchAttLog.date_end, type: context.searchAttLog.type})).onSuccess(function(response) {
          context.tableAttLog.data = response.data.data;
          context.notify('Data Retrieved Successfully', 'success')
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.tableAttLog.data = [];
          }
          context.notify('Data Retrieved Failed', 'error')
      }).onFinish(function() { 
         context.onLoading             = false;
         context.formFilterAttLog.show = false;
      })
      .call()
    },
    getHisLembur(){
      let context = this;    
      this.onLoading = true;

      Api(context, dataAbsensi.getHisLembur({nama: context.searchHisLembur.nama, unit: context.searchHisLembur.unit, tanggal_start: context.searchHisLembur.tanggal_start, tanggal_end: context.searchHisLembur.tanggal_end, code_spl: context.searchHisLembur.code_spl, created_by: context.searchHisLembur.created_by, status_approval: context.searchHisLembur.status_approval })).onSuccess(function(response) {
          context.tableHisLembur.data = response.data.data;
          context.notify('Data Retrieved Successfully', 'success')
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.tableHisLembur.data = [];
          }
          context.notify('Data Retrieved Failed', 'error')
      }).onFinish(function() { 
         context.onLoading             = false;
         context.formFilterHisLembur.show = false;
      })
      .call()
    },
    getHisCuti(){
      let context = this;    
      this.onLoading = true;

      Api(context, dataAbsensi.getHisCuti({dibuat_oleh: context.searchHisCuti.dibuat_oleh, tanggal_start: context.searchHisCuti.tanggal_start, tanggal_end: context.searchHisCuti.tanggal_end, type: context.searchHisCuti.type, status_approval: context.searchHisCuti.status_approval })).onSuccess(function(response) {
          context.tableHisCuti.data = response.data.data;
          context.notify('Data Retrieved Successfully', 'success')
      }).onError(function(error) {                    
          if (error.response.status == 404) {
              context.tableHisCuti.data = [];
          }
          context.notify('Data Retrieved Failed', 'error')
      }).onFinish(function() { 
         context.onLoading              = false;
         context.formFilterHisCuti.show = false;
      })
      .call()
    },
    createLog() {
      this.formEditAttLogs.add   = true;
      this.formEditAttLogs.show  = true;
      this.formEditAttLogs.title = "Add Data Att Logs";
      this.dataAttLogs           = {};
    },
    editAttLogs(id) {
      let context = this;               
      Api(context, attendanceLog.show(id)).onSuccess(function(response) {
          context.dataAttLogs            = response.data.data;
          context.formEditAttLogs.show   = true;
          context.formEditAttLogs.title  = 'Edit Data Att Logs';       
      })
      .call()        
    },
    saveAttLogs(){
      let api      = null;
      let context  = this;
      let formData = new FormData();

      if (context.dataAttLogs.pin != undefined && context.dataAttLogs.shift != undefined && context.dataAttLogs.date != undefined && context.dataAttLogs.time != undefined && context.dataAttLogs.type != undefined) {
        formData.append('pin', context.dataAttLogs.pin);
        formData.append('shift', context.dataAttLogs.shift);
        formData.append('date', context.dataAttLogs.date);
        formData.append('time', context.dataAttLogs.time);
        formData.append('type', context.dataAttLogs.type);
      }else{
        return alert('Field Bintang Merah Wajib Di Isi')
      }

      if (context.formEditAttLogs.title == 'Add Data Att Logs') {
          api = Api(context, attendanceLog.create(formData));
      } else {
          api = Api(context, attendanceLog.update(context.dataAttLogs.id, formData));
      }
      // eslint-disable-next-line no-unused-vars
      api.onSuccess(function(response) {
        context.getAttLog();
        context.formEditAttLogs.show = false;
        context.notify((context.formEditAttLogs.title === 'Add Data') ? 'Data Berhasil di Simpan' : 'Data Berhasil di Update', 'success')
      // eslint-disable-next-line no-unused-vars
      }).onError(function(error) { 
        context.notify((context.formEditAttLogs.title != 'Add Data') ? 'Data Gagal di Simpan' : 'Data Gagal di Update', 'error')                   
      }).onFinish(function() {  
      })
      .call();
    },
    removeAttLog(id) {
      var r = confirm("Anda yakin ingin menghapus data ini ?");
      if (r == true) {
        let context = this;

        Api(context, attendanceLog.deleteLog(id)).onSuccess(function(response) {
            context.getAttLog();
            context.notify('Data Successfully Deleted', 'success')
        }).call();
      }
    },
    editLembur(id) {
      let context = this;
      Api(context, approvalLembur.editLembur(id)).onSuccess(function(response) {
          context.dataLembur           = response.data.data;
          context.formEditLembur.show  = true;
          context.formEditLembur.title = 'Edit Data Lembur';
      })
      .call()
    },
    createLembur() {
      // Same random 8-char code generator used for "Buat SPL" on Detail
      // Profile -- a brand new SPL always needs one, nothing to reuse here
      // since (unlike that page) this form is always a single employee.
      let length = 8;
      let result = '';
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
      }
      this.dataLembur = { code_spl: result, status_approval: 'Waiting' };
      this.formEditLembur.show  = true;
      this.formEditLembur.title = 'Add Data Lembur';
    },
    saveLembur(){
      let api      = null;
      let context  = this;
      let formData = new FormData();

      if (context.formEditLembur.title == 'Add Data Lembur') {
        if (context.dataLembur.id_karyawan && context.dataLembur.tanggal && context.dataLembur.actual_jam != undefined && context.dataLembur.uraian_pekerjaan && context.dataLembur.status_approval) {
          formData.append('code_spl', context.dataLembur.code_spl);
          formData.append('id_karyawan', context.dataLembur.id_karyawan);
          formData.append('tanggal', context.dataLembur.tanggal);
          formData.append('jam', context.dataLembur.actual_jam);
          formData.append('uraian_pekerjaan', context.dataLembur.uraian_pekerjaan);
          formData.append('status_approval', context.dataLembur.status_approval);
        } else {
          return alert('Field Bintang Merah Wajib Di Isi')
        }
        api = Api(context, approvalLembur.create(formData));
      } else {
        if (context.dataLembur.id != undefined && context.dataLembur.actual_jam != undefined) {
          formData.append('id_karyawan', context.dataLembur.id_karyawan);
          formData.append('tanggal', context.dataLembur.tanggal);
          formData.append('actual_jam', context.dataLembur.actual_jam);
        }else{
          return alert('Field Bintang Merah Wajib Di Isi')
        }
        api = Api(context, approvalLembur.updateLembur(context.dataLembur.id, formData));
      }

      // eslint-disable-next-line no-unused-vars
      api.onSuccess(function(response) {
        context.notify((context.formEditLembur.title === 'Add Data Lembur') ? 'Data Berhasil di Simpan' : 'Data Berhasil di Update', 'success')
      }).onError(function(error) {
        context.notify(error.response?.data?.message || ((context.formEditLembur.title === 'Add Data Lembur') ? 'Data Gagal di Simpan' : 'Data Gagal di Update'), 'error')
      }).onFinish(function() {
        context.getHisLembur();
        context.formEditLembur.show = false;
      })
      .call();
    },
    removeLembur(id) {
      var r = confirm("Anda yakin ingin menghapus data ini ?");
      if (r == true) {
        let context = this;

        Api(context, approvalLembur.deleteAnggota(id)).onSuccess(function(response) {
            context.getHisLembur();
            context.notify('Data Successfully Deleted', 'success')
        }).call();
      }
    },
    createCuti() {
      this.formEditCuti.add   = true;
      this.formEditCuti.show  = true;
      this.formEditCuti.title = "Add Data Cuti / Izin";
      this.dataCuti           = {};
    },
    editCuti(id) {
      let context = this;               
      Api(context, approvalCuti.show(id)).onSuccess(function(response) {
          context.dataCuti           = response.data.data;
          context.formEditCuti.show  = true;
          context.formEditCuti.title = 'Edit Data Cuti';       
      })
      .call()        
    },
    filesChangeCuti(e) {
      this.dataCuti.bukti = e.target.files[0];
    },
    saveCuti(){
      let api      = null;
      let context  = this;
      let formData = new FormData();
      let isAdd    = context.formEditCuti.title == "Add Data Cuti / Izin";

      if (
        context.dataCuti.id_karyawan != undefined && context.dataCuti.id_karyawan != '' &&
        context.dataCuti.alasan_cuti != undefined && context.dataCuti.alasan_cuti != '' &&
        context.dataCuti.dari_tanggal != undefined && context.dataCuti.dari_tanggal != '' &&
        context.dataCuti.sampai_tanggal != undefined && context.dataCuti.sampai_tanggal != '' &&
        context.dataCuti.type != undefined && context.dataCuti.type != '' &&
        context.dataCuti.status_approval != undefined && context.dataCuti.status_approval != ''
      ) {
        // Surat sakit is required by the backend whenever type=Sakit on a
        // new submission (ApprovalCutiController::store) -- without this,
        // Admin's "Add Data Cuti / Izin" form had no way to attach one, so
        // picking "Sakit" always failed validation.
        if (isAdd && context.dataCuti.type == 'Sakit' && !(context.dataCuti.bukti instanceof File)) {
          return alert('Surat Sakit Wajib Diisi Untuk Pengajuan Sakit')
        }

        formData.append('id_karyawan', context.dataCuti.id_karyawan);
        formData.append('dari_tanggal', context.dataCuti.dari_tanggal);
        formData.append('alasan_cuti', context.dataCuti.alasan_cuti);
        formData.append('sampai_tanggal', context.dataCuti.sampai_tanggal);
        formData.append('type', context.dataCuti.type);
        formData.append('status_approval', context.dataCuti.status_approval);
        if (isAdd && context.dataCuti.bukti instanceof File) {
          formData.append('bukti', context.dataCuti.bukti);
        }
      }else{
        return alert('Field Bintang Merah Wajib Di Isi')
      }

      if (isAdd) {
          api = Api(context, approvalCuti.create(formData));
      } else {
          api = Api(context, approvalCuti.updateCuti(context.dataCuti.id, formData));
      }
      // eslint-disable-next-line no-unused-vars
      api.onSuccess(function(response) {
        context.notify(isAdd ? 'Data Berhasil di Simpan' : 'Data Berhasil di Update', 'success')
        context.formEditCuti.show = false;
      }).onError(function(error) {
        context.notify(error.response?.data?.message || (isAdd ? 'Data Gagal di Simpan' : 'Data Gagal di Update'), 'error')
      }).onFinish(function() {
        context.getHisCuti();
      })
      .call();
    },
    removeCuti(id) {
      var r = confirm("Anda yakin ingin menghapus data ini ?");
      if (r == true) {
        let context = this;

        Api(context, approvalCuti.delete(id)).onSuccess(function(response) {
            context.getHisCuti();
            context.notify('Data Successfully Deleted', 'success')
        }).call();
      }
    },
    getRole(){
      let context = this;     
      context.onLoading = true;
      Api(context, akun.indexProfile()).onSuccess(function(response) {
          context.role = response.data.data[0].role;
          if (response.data.data[0].role != 'Admin') {
            context.$router.push({ path: /detail-profile/+response.data.data[0].employee_id})
          }
      }).onError(function(error) {  
      })
      .call() 
    },
    filter() {
      this.formFilter.add   = true;
      this.formFilter.show  = true;
      this.formFilter.title = "Filter";
      this.onLoading        = false;
      this.search.periode   = this.search.periode_start ? moment(this.search.periode_start).format('YYYY-MM') : defaultPeriode();
    },
    onPeriodeFilterChange() {
      const range = periodeToRange(this.search.periode);
      this.search.periode_start = range.start;
      this.search.periode_end   = range.end;
    },
    create() {
      this.form.add        = true;
      this.form.show       = true;
      this.form.title      = "Create Periode Absensi";
      this.onLoading        = false;
      this.karyawan.periode = defaultPeriode();
      this.onPeriodeCreateChange();
    },
    onPeriodeCreateChange() {
      const range = periodeToRange(this.karyawan.periode);
      this.karyawan.periode_start = range.start;
      this.karyawan.periode_end   = range.end;
    },
    setLibur() {
      this.formLibur.add   = true;
      this.formLibur.show  = true;
      this.formLibur.title = "Set Tanggal Libur / Tanggal Merah";
      this.onLoading       = false;
    },
    filterAttLog() {
      this.formFilterAttLog.add   = true;
      this.formFilterAttLog.show  = true;
      this.formFilterAttLog.title = "Filter Att Log";
      this.onLoading              = false;
    },
    filterHisLembur() {
      this.formFilterHisLembur.add   = true;
      this.formFilterHisLembur.show  = true;
      this.formFilterHisLembur.title = "Filter History Lembur";
      this.onLoading                 = false;
    },
    filterHisCuti() {
      this.formFilterHisCuti.add   = true;
      this.formFilterHisCuti.show  = true;
      this.formFilterHisCuti.title = "Filter History Cuti / Sakit";
      this.onLoading               = false;
    },
    save(){
      let api      = null;
      let context  = this;
      this.onLoading = true;
      let formData = new FormData();

      if (context.karyawan.periode_start != undefined && context.karyawan.periode_end != undefined) {
        // formData.append('id_karyawan', context.karyawan.id_karyawan);
        // formData.append('nama', context.karyawan.nama);
        // formData.append('type', context.karyawan.type);
        formData.append('periode_start', context.karyawan.periode_start);
        formData.append('periode_end', context.karyawan.periode_end);
      }else{
        return alert('Field Bintang Merah Wajib Di Isi')
      }

      api = Api(context, dataAbsensi.create(formData));
      // eslint-disable-next-line no-unused-vars
      api.onSuccess(function(response) {
        context.getAbsen();
        context.form.show = false;
        context.notify('Created Success', 'success')
      // eslint-disable-next-line no-unused-vars
      }).onError(function(error) {                    
        context.notify('Created Failed', 'error')
      }).onFinish(function() { 
         context.onLoading = false; 
      })
      .call();
    },
    setLiburGo(){
      let api      = null;
      let context  = this;
      this.onLoading = true;

      let formData = new FormData();

      if (context.setDataLibur.tanggal != undefined) {
        formData.append('periode_start', context.search.periode_start);
        formData.append('periode_end', context.search.periode_end);
        formData.append('tanggal', context.setDataLibur.tanggal);
      }else{
        return alert('Field Bintang Merah Wajib Di Isi')
      }

      api = Api(context, dataAbsensi.setLibur(formData));
      // eslint-disable-next-line no-unused-vars
      api.onSuccess(function(response) {
        context.getAbsen();
        context.notify('Created Success', 'success')
      // eslint-disable-next-line no-unused-vars
      }).onError(function(error) {                    
        context.notify('Created Failed', 'error')
      }).onFinish(function() {
         context.onLoading = false;
         context.formLibur.show = false;
      })
      .call();
    },
    setCutiBersama() {
      this.formSetCuti.show = true;
      this.dataSetCuti      = {};
      this.onLoading        = false;
    },
    setCutiBersamaGo(){
      let api      = null;
      let context  = this;
      this.onLoading = true;

      if (context.dataSetCuti.dari_tanggal == undefined || context.dataSetCuti.dari_tanggal == '' ||
          context.dataSetCuti.sampai_tanggal == undefined || context.dataSetCuti.sampai_tanggal == '') {
        this.onLoading = false;
        return alert('Field Bintang Merah Wajib Di Isi')
      }

      api = Api(context, approvalCuti.setCutiAll({
          dari_tanggal: context.dataSetCuti.dari_tanggal,
          sampai_tanggal: context.dataSetCuti.sampai_tanggal,
          alasan_cuti: context.dataSetCuti.alasan_cuti,
      }));
      // eslint-disable-next-line no-unused-vars
      api.onSuccess(function(response) {
        context.getAbsen();
        context.notify('Cuti Bersama Berhasil Diterapkan Ke Semua Karyawan', 'success')
      // eslint-disable-next-line no-unused-vars
      }).onError(function(error) {
        context.notify('Set Cuti Bersama Gagal', 'error')
      }).onFinish(function() {
         context.onLoading = false;
         context.formSetCuti.show = false;
      })
      .call();
    },
    updateAbsen(id, value, type, unit_user, type_hari){
      let api     = null;
      let context = this;

      api = Api(context, dataAbsensi.updateAbsen({
          id: id,
          value: value,
          type: type,
          unit_user: unit_user,
          type_hari: type_hari, 
      }));
      api.onSuccess(function(response) {
          context.notify('Update Success', 'success')
      }).onError(function(error) { 
          context.notify('Update Failed', 'error')
      }).onFinish(function() {  
          context.getAbsen();
      })
      .call();
    },
    cekLembur() {
      this.formCekLembur.show   = true;
      this.tableCekLembur.data  = [];
      this.cekLemburSudahDicek  = false;
      this.filterCekLembur      = { nama: '', tanggal_start: '', tanggal_end: '', unit: '', status_cek: 'perlu_perhatian' };
      this.cekLemburPreview();
    },
    formatJamMenit(totalMenit) {
      const jam  = Math.floor(totalMenit / 60);
      const menit = totalMenit % 60;
      return jam + ' jam ' + menit + ' menit';
    },
    cekLemburPreview() {
      let context = this;
      context.onLoadingCekLembur = true;

      Api(context, approvalLembur.cekLemburPreview({
        periode_start: context.search.periode_start,
        periode_end: context.search.periode_end,
        // Scopes the check itself to the current nama/unit/tanggal filter
        // (status_cek stays client-side -- it's computed FROM this fetch,
        // so it can't narrow the fetch, and narrowing by it would also
        // break the summary badge counts above the table).
        nama: context.filterCekLembur.nama,
        unit: context.filterCekLembur.unit,
        tanggal_start: context.filterCekLembur.tanggal_start,
        tanggal_end: context.filterCekLembur.tanggal_end,
      })).onSuccess(function(response) {
        // Pre-checked by default (closest to the old "always applies to
        // everything" behaviour) -- Admin unchecks specific rows to skip
        // them, or narrows the filter first.
        context.tableCekLembur.data = (response.data.data || []).map(function(row) {
          // 'Sesuai' and 'Sudah Dikoreksi' need no action -- leave them
          // unchecked by default so a routine "Terapkan" click doesn't
          // needlessly re-touch rows that are already fine. Exception:
          // perlu_set_libur rows DO still need something done (flipping
          // absen.type_hk to 'L') even when their hours are perfectly
          // "Sesuai" -- without this they'd be unchecked, hidden by the
          // default "Perlu Perhatian" filter, and the holiday flag would
          // never get applied.
          const needsAction = (row.status_cek != 'Sesuai' && row.status_cek != 'Sudah Dikoreksi') || row.perlu_set_libur;
          return { ...row, selected: needsAction };
        });
        context.cekLemburSudahDicek = true;
      }).onError(function() {
        context.notify('Gagal memeriksa data lembur', 'error')
      }).onFinish(function() {
        context.onLoadingCekLembur = false;
      })
      .call();
    },
    toggleAllVisibleCekLembur(checked) {
      this.filteredCekLembur.forEach(function(row) {
        row.selected = checked;
      });
    },
    applyCekLembur() {
      let context = this;
      let ids      = this.selectedFilteredCekLembur.map(function(r) { return r.id; });

      if (ids.length == 0) {
        return alert('Pilih minimal satu baris untuk diterapkan');
      }

      var r = confirm("Terapkan koreksi ke " + ids.length + " baris yang tercentang & sesuai filter? SPL tanpa kehadiran akan ditolak otomatis, dan jam lembur yang tidak sesuai akan disesuaikan dengan kehadiran aktual.");
      if (!r) { return; }

      context.onLoadingCekLembur = true;

      Api(context, approvalLembur.applyCekLembur({
        ids: ids,
      })).onSuccess(function(response) {
        context.notify('Selesai: ' + response.data.data.dikoreksi + ' dikoreksi, ' + response.data.data.direject + ' ditolak otomatis, ' + response.data.data.sesuai + ' sudah sesuai', 'success')
        // Modal stays open and re-checks in place -- Admin can immediately
        // see the updated result and apply further corrections without
        // closing/reopening and waiting through the whole load again.
        // cekLemburPreview() owns onLoadingCekLembur from here (it sets it
        // true then false around its own request), so it's NOT reset below
        // -- doing so would flip it false while that refetch is still in
        // flight, hiding the loading spinner too early.
        context.cekLemburPreview();
        context.getHisLembur();
        context.getAbsen();
      }).onError(function() {
        context.notify('Gagal menerapkan koreksi lembur', 'error')
        context.onLoadingCekLembur = false;
      })
      .call();
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, {
          autoClose: 2000,
        }); // ToastOptions
      }else{
        toast.error(message, {
          autoClose: 2000,
        }); // ToastOptions
      }
    },
    setBg(id) {
      this.backgroundRed = id
    }
  }
};
</script>
<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;

}
::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 500px;
  margin-top: auto;
  margin-bottom: auto;
}
::v-deep .modal-content-width {
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  max-width: 95vw;
  max-height: 90vh;
  overflow-y: auto;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
</style>

<style scoped>
.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
.scroll { 
  overflow: auto; 
  height: 600px; 
}
.scroll thead th { 
  position: sticky; 
  top: 0; 
  z-index: 100; 
  background-color: #6495ED; 
}

/*for freze ke samping*/
.scroll table td:first-child {
  position: sticky;
  left: 0;
  background-color: #ddd;
}

/* Freeze the "No" + "Nama"/"Dibuat Oleh" columns while scrolling
   horizontally -- only on Attendance Logs, History Lembur and History
   Cuti/Sakit (wherever .scroll-freeze2 is added alongside .scroll), not
   every .scroll table on this page. The thead rules below MUST stay more
   specific than the body-cell rules (same nth-child, but with the extra
   "thead" + ".scroll" tightened on), otherwise the white body background
   wins the cascade on the header cells too -- which is exactly the bug
   that left the frozen "NO" header plain white instead of blue. */
.scroll.scroll-freeze2 tbody td:nth-child(1) {
  position: sticky;
  left: 0;
  z-index: 10;
  background-color: #fff;
}
.scroll.scroll-freeze2 tbody td:nth-child(2) {
  position: sticky;
  left: 56px;
  z-index: 10;
  background-color: #fff;
}
.scroll.scroll-freeze2 thead th:nth-child(1) {
  position: sticky;
  left: 0;
  z-index: 110;
  background-color: #6495ED;
}
.scroll.scroll-freeze2 thead th:nth-child(2) {
  position: sticky;
  left: 56px;
  z-index: 110;
  background-color: #6495ED;
}
</style>
